import React, { useState } from "react";
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as ProducerActions from "features/settings/producers/producers.action";
import { Producer } from "features/settings/producers/producer";
import ValidationError from "common/validationError";
import { MultipleCellPhoneRegex, PhoneRegex } from "common/validation";
import ErrorList from "common/ui/ErrorList";
import IAppStore from "app/IAppStore";
import "./ProducerAdditionalContact.scss";
//Pass in the producer.
const SetProducerAdditionalContactDetails: React.FC<{producer: Producer}> = (props: {producer: Producer}) => {
    const [producer, setProducer] = useState<Producer>(props.producer);
    const [errors, setErrors] = useState<string[]>([]);
    const [validated, setValidated] = useState<boolean>(false);
    const [editMode, setEditMode] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isCustomer = useSelector((m: IAppStore) => m.userState.isCustomer);
    const formRef = React.createRef<HTMLFormElement>();

    const dispatch = useDispatch();

    async function handleSubmit() {
        if (formRef.current.checkValidity() ) {
            setIsSubmitting(isCustomer && true);
            setErrors([]);
            try {
                if(isCustomer)
                {
                    await ProducerActions.updateProducerContact(dispatch, producer, props.producer);                
                    setEditMode(false);
                }
                else
                {
                    ProducerActions.updateProducer(producer, props.producer)(dispatch);
                }
            }
            catch (err) {
                setErrors((err as ValidationError).errors);
            }
            finally {
                setIsSubmitting(false);
            }
        }
        setValidated(true);
    }

    function handleAbort() {
        setEditMode(false);
        setIsSubmitting(false);
        setProducer(props.producer);
    }

    return <>
        {producer && <Container>
        <Form noValidate validated={validated} ref={formRef}>
            {isCustomer && <>
                <Form.Group as={Row}>
                    <Col md={editMode ? "7" : "10"} className="pl-0">
                        <div className="producer-contact-header">Contact</div>
                    </Col>
                    <Col md={editMode ? "5" : "2"} className="px-0">
                        {editMode && <>
                            <Button variant="secondary" onClick={handleAbort}>
                                Cancel
                            </Button>&nbsp;
                            <Button variant="primary" onClick={handleSubmit}>
                                Save 
                                {isSubmitting && <Spinner animation="border" size="sm" className="producer-contact-save" />}
                            </Button>
                        </>}
                        {!editMode && <Button variant="primary" onClick={() => setEditMode(true)}>
                            Edit
                        </Button>}
                    </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-0">
                    <Form.Label className="required">Phone Number</Form.Label>
                </Form.Group>
                <Form.Group as={Row}>
                    <Form.Control
                        type="text"
                        name="phone"
                        pattern={PhoneRegex.source}
                        value={producer.phone}
                        onChange={(event: any) => setProducer({ ...producer, phone: event.target.value?.trim() })}
                        disabled={isCustomer && !editMode}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid phone number.
                    </Form.Control.Feedback>
                </Form.Group>
            </>}
            <Form.Group as={Row} className="mb-0">
                <Form.Label>Additional Emails</Form.Label>
            </Form.Group>
            <Form.Group as={Row}>
                    <Form.Control
                        type="email"
                        name="email"
                        multiple
                        value={producer.additionalEmails ?? ''}
                        onChange={(event: any) => setProducer({ ...producer, additionalEmails: event.target.value?.trim() })}
                        onBlur={() => !isCustomer && handleSubmit()}
                        disabled={isCustomer && !editMode}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">Please provide valid emails.</Form.Control.Feedback>
                    <span className="small text-secondary">Use commas to add multiple emails</span>
            </Form.Group>
    
            <Form.Group as={Row} className="mb-0">
                <Form.Label>Additional Cell Phones</Form.Label>
            </Form.Group>
            <Form.Group as={Row}>
                <Form.Control
                    type="text"
                    name="additionalPhones"
                    pattern={MultipleCellPhoneRegex.source}
                    value={producer.additionalPhones ?? ''}
                    onChange={(event: any) => setProducer({ ...producer, additionalPhones: event.target.value?.trim() })}
                    onBlur={() => !isCustomer && handleSubmit()}
                    disabled={isCustomer && !editMode}
                ></Form.Control>
                <Form.Control.Feedback type="invalid">Please provide valid cell phones.</Form.Control.Feedback>
                <span className="small text-secondary">Use commas to add multiple cell #'s</span>
            </Form.Group>

            <div className="row">
                <ErrorList errors={errors} />
            </div>
        </Form>
        </Container>}
    </>;
}

export default SetProducerAdditionalContactDetails;